// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__jVn-+","text":"NoData_text__A8X63"};